import credentials from "../../assets/credentials";

const Download = ({ downloadLink }) => {
  const imageUrl = `${credentials.download_URL}/cover/${downloadLink.image}`;
  const audioUrl = `${credentials.download_URL}/music/${downloadLink.audio}`;
  return (
    <div className="download">
      <button>
        {" "}
        <a href={imageUrl}> Download Image </a>{" "}
      </button>
      <button>
        <a href={audioUrl}>Download Audio</a>
      </button>
    </div>
  );
};
export default Download;
